import { ColDef } from 'ag-grid-community';
import { suppressPricingGridKeyboardEvent } from '../utils/clientDataKeyboardShortcutSuppressionUtils';

export const PricingSheetTableAgGrid = 'PricingSheetBase';

export const rowSpanHeaderWidthVertical = 29;
export const rowSpanHeaderWidthHorizontalExtended = 110;
export const rowSpanHeaderWidthHorizontal = 75;
export const lengthColumnWidth = 54;
export const widthLengthColumnWidth = 69;
export const priceColumnWidth = 80;
export const decimalPriceColumnWidth = 92;

export const defaultColumn: ColDef = {
  resizable: false,
  sortable: false, // do not allow column sorting
  suppressMenu: true, // suppress the column hamburger menu
  suppressMovable: true, // do not allow column dragging
  cellClassRules: {
    'ag-grid-custom-black-out-cell-color': (params) => {
      const { data, colDef } = params;
      const columnId = colDef.colId || params.column.getColId();
      if (!params.value && !data[columnId]) {
        return true;
      }
      return false;
    },
  },
  editable: true,

  suppressKeyboardEvent: suppressPricingGridKeyboardEvent,
};

export enum PricingSkuColumn {
  SkuPrice = 'skuPrice',
  SkuRegion1 = 'skuRegion1',
  SkuRegion2 = 'skuRegion2',
  SkuRegion3 = 'skuRegion3',
  SkuRegion4 = 'skuRegion4',
  SkuRegion5 = 'skuRegion5',
  SkuRegion6 = 'skuRegion6',
  SkuRegion7 = 'skuRegion7',
}

export enum GridDataType {
  Price = 'price',
  Sku = 'sku',
}

export enum GridOptionCategory {
  View = 'view',
  Data = 'data',
}
